// extracted by mini-css-extract-plugin
export default {"root":"VideoPlayerModal_root__cU7Ce","videoWrapper":"VideoPlayerModal_videoWrapper__B03tr","video":"VideoPlayerModal_video__iOCgR"};